angular.module('core').filter('language', ['lcidConstants',
    function(lcidConstants) {
        return function(languageId) {
            if(_.isString(languageId)) {
              languageId = parseInt(languageId);
            }

            if( _.isNaN(languageId) || _.isUndefined(languageId) ) {
                return '';
            }

            switch (languageId) {
                case lcidConstants.SPANISH_US:
                    return "Spanish";
                default:
                  return "English";
            }
        };
    }
]);
